module.exports = __webpack_public_path__ + "static/media/m-bg-2.25a14957.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/m/m-bg-2.png
// module id = 55
// module chunks = 3